export default {
  FIELD_IS_REQUIRED: 'To pole jest wymagane!',
  PASSWORD_LENGTH: 'Musi mieć więcej niż 8 znaków!',
  WRONG_EMAIL_OR_PASSWORD: 'Nieprawidłowy mail lub hasło',
  SOMETHING_WENT_WRONG: 'Coś poszło nie tak! Spróbuj ponownie',
  PASSWORD_TOO_WEAK: 'Hasło nie spełnia wymagań',
  INCORRECT_PHONE_NUMBER: 'Nieprawidłowy numer telefonu',
  INCORRECT_EMAIL: 'Nieprawidłowy adres email',
}
